import LayoutPage from "../../Components/LayoutPage";
import CustomerList from "./Components/CustomerList";

export default function Customers() {
  return (
    <LayoutPage
      activeIndex={5}
      navItems={["مدیریت مشتریان"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <CustomerList />
    </LayoutPage>
  );
}
